import { T } from '@jsx6/jsx6'

export const areaChat = (chat) => {
  // let title = window.CHAT_TITLE || t('chat')
  return (
    <div p="area.chat" hidden>
      <div class="chatHeading">
        <div class="left">
          <div p="iconChat" class="agent-avatar" icon="bot" selector="--avatar-icon-color"></div>
          <div p="agentNickname" selector="--heading-color">{T`agent`}</div>
        </div>
        <div class="header-actions">
          <div class="call-actions" p="callActions" hidden>
            <span p="settingsButton" class="header-action-btn" icon="gear" onclick={e => chat.toggleSettings()} hidden></span>
            <div class="call-settings">
              <span icon="video-off" p="bt.videoDisabled" onclick={e => chat.mediaVideo(true)} hidden></span>
              <span icon="video-call" p="bt.videoEnabled" onclick={e => chat.mediaVideo(false)} hidden></span>
              <span icon="mic-off" p="bt.audioDisabled" onclick={e => chat.mediaSound(true)} hidden></span>
              <span icon="microphone-1" p="bt.audioEnabled" onclick={e => chat.mediaSound(false)} hidden></span>
            </div>
            <span icon="call-end" class="header-action-btn" p="bt.callEnd" onclick={e => chat.callFinished(true)}></span>
          </div>
          <span p="chatEnd" onclick={e => chat.end()} icon="x-mark" />
        </div>
      </div>
      <div p="callDialog" class="call-dialog" hidden>
        <div class="call-info" p="callInfo" >
          <div class="call-time" p="callCounter" id="callCounter">
            00:00
          </div>
          <span p="signalQuality" x-title="Video signal" style="height:20px; width:20px; border-radius: 999px; background-color: green;" hidden></span>

          <div class="device-agent-feedback">
            <span x-title="Agent turned off camera" p="agentVideoOff" hidden icon="video-off"></span>
            <span x-title="Agent muted microphone" p="agentMicOff" hidden icon="mic-off"></span>
          </div>
        </div>
        <div p="videoDialog" class="video-dialog">
          <div class="callInfo" hidden>
            <p class="callSubheading" hidden></p>
          </div>
          <div class="videoWrapper" p="areaVideo" hidden>
            <div class="videoAgent" p="area2.chatVideoIn"></div>
            <div class="videoClient" p="area2.chatVideoOut"></div>
            <span p="switchVideo" icon="switch-video" hidden></span>
          </div>
        </div>
        <div p="audioDialog"></div>
      </div>

      <div class="chat-msgs-wrapper">
        <div p="chatMessages"></div>
      </div>

      <div p="sendBox" class="sendBox">
        <span hidden><input p="fileUploadField" type="file"/></span>

        <div p="sendboxWrapper" class="sendbox-wrapper">
          <textarea p="chatMessageInput" rows="2" placeholder={T`type_message`}></textarea>
          <div class="sendbox-actions">
            <div class="actions-left">
              <span p="requestFileUpload" class="bt-icon" onclick={e => chat.initFileUpload()} icon="attach" title={T`attachment`}></span>
            </div>
            <div class="actions-right">
              <span p="sendButton" class="bt-icon" onclick={e => chat.sendChatMessage()} icon="send" title={T`send`}></span>
            </div>
          </div>
        </div>
        <div p="surveyButtonWrapper" hidden>
          <button class='btn btn-primary' onclick={e => chat.showSurvey(true)}>
            {T`open_survey`}
          </button>
          <button class='btn' onclick={e => chat.leave()}>
            {T`end_chat`}
          </button>
        </div>
        <div p="closeButtonWrapper" hidden>
          <div p="surveyThankYouMessage"></div>
          <button class='btn btn-primary' onclick={e => chat.closeChat()}>
            {T`close`}
          </button>
        </div>

        <div class="chatFooter">
          {chat.$s.logo}
        </div>
      </div>
      <div class='deviceSettings' p='deviceSettings' hidden>
        <div class='settingsHeader'>
          <span icon='x-mark' onclick={e => chat.toggleSettings()}></span>
          <p class='settingsHeading'>{T`device_settings`}</p>
        </div>
        <div p='sessionSettings'></div>
        <div class='form-line buttons-line'>
          <button p='bt.start' class='btn btn-primary' onclick={e => chat.toggleSettings()}>
            {T`close_settings`}
          </button>
        </div>
      </div>
    </div>
  )
}
